import * as React from "react";
import styled from "styled-components";

import Style from "@client/utils/Style";

const backgroundColor = (props: any) => {
  if (props.hollow) {
    return "white";
  }
  if (props.secondary) {
    return Style.palette.secondaryLight;
  }
  if (props.alert) {
    return Style.palette.alert;
  }
  if (props.highlight) {
    return Style.palette.primaryHighlight;
  }
  return Style.palette.primary;
};
const disabledBackgroundColor = (props: any) => {
  if (props.secondary && props.hollow) {
    return Style.palette.grayscale[7];
  }
  return backgroundColor(props);
};

const hoverBackgroundColor = (props: any) => {
  if (props.disabled && props.secondary && props.hollow) {
    return Style.palette.grayscale[7];
  }
  if (props.secondary) {
    return Style.palette.grayscale[8];
  }
  if (props.hoverPrimary) {
    return Style.palette.primary;
  }
  if (props.alert) {
    return Style.palette.alert;
  }
  if (props.highlight) {
    return Style.palette.primaryHighlight;
  }
  return Style.palette.primary;
};

const border = (props: any) => {
  if (props.hollow) {
    if (props.secondary) {
      return `border: 1px solid ${Style.palette.grayscale[3]};`;
    }
    if (props.alert) {
      return `border: 1px solid ${Style.palette.alert};`;
    }
    if (props.highlight) {
      return `border: 1px solid ${Style.palette.primaryHighlight};`;
    }
    return `border: 1px solid ${Style.palette.primary};`;
  }
  return "";
};
const disabledBorder = (props: any) => {
  if (props.secondary && props.hollow) {
    return "border: none;";
  }
  return border(props);
};

const color = (props: any) => {
  if (props.hollow) {
    if (props.secondary) {
      return props.disabled ? Style.palette.grayscale[3] : Style.palette.black;
    }
    if (props.alert) {
      return Style.palette.alert;
    }
    if (props.highlight) {
      return Style.palette.primaryHighlight;
    }
    return Style.palette.primary;
  }
  return "white";
};
const hoverColor = (props: any) => {
  if (props.hollow) {
    if (props.disabled) {
      return Style.palette.grayscale[3];
    }
    return "white";
  }
  return "";
};
const getWidth = (props: any) => {
  if (props.width) {
    return props.width;
  }

  if (props.large) {
    return `${Style.inputSizes.large.width}px`;
  }
  return `${Style.inputSizes.regular.width}px`;
};
const StyledButton = styled.button`
  ${Style.exactHeight("32px")}
  border-radius: 4px;
  margin: 0;
  background-color: ${props => backgroundColor(props)};
  border: none;
  ${props => border(props)}
  color: ${props => color(props)};
  padding: 0;
  ${(props: any) => Style.exactWidth(getWidth(props))}
  cursor: pointer;
  font-size: inherit;
  transition:
    background-color ${Style.animations.swift},
    opacity ${Style.animations.swift};
  &:disabled {
    opacity: ${(props: any) => (props.secondary ? 1 : 0.7)};
    cursor: not-allowed;
    background-color: ${props => disabledBackgroundColor(props)};
    ${props => disabledBorder(props)}
  }
  &:hover {
    color: ${(props: any) => hoverColor(props)};
    background-color: ${props => hoverBackgroundColor(props)};
  }
  &:focus {
    outline: none;
  }
`;

const Button = (props: any) => (
  <StyledButton
    {...props}
    onFocus={e => {
      e.target.blur();
    }}
  />
);

export default Button;
